export { AtnDsToggleButtonComponent as Component } from './toggle-button.component'
